import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ["modal", "overlay"]

  connect() {
    this.startY = 0
    this.currentY = 0
    this.isDragging = false
    this.threshold = 100;
    this.updateConditionButtons();
  }

  openModal(event) {
    this.modalTargets.forEach(modal => modal.classList.remove("is-open"));
    const modalType = event?.currentTarget?.dataset?.modal;
    const targetModal = this.modalTargets.find(modal => modal.dataset.modal === modalType) || this.modalTargets[0];
    targetModal.classList.add("is-open");
    this.overlayTarget.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  closeModal() {
    this.modalTargets.forEach(modal => {
      modal.classList.remove("is-open");
      modal.style.transform = "";
    });
    this.overlayTarget.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.closeModal()
    }
  }

  applyAndClose() {
    this.closeModal();
    this.updateConditionButtons();
    this.dispatch("applied", { bubbles: true });
  }

  updateConditionButtons() {
    this.element.querySelectorAll('.companies-search-card__conditions-button[data-modal]').forEach(button => {
      const modalType = button.dataset.modal;
      const modal = this.modalTargets.find(m => m.dataset.modal === modalType);
      if (!modal) return;
      const checkboxSelectors = [
        '.companies-search-modal__section-checkbox:checked',
        '.companies-search-modal-industry__checkbox:checked',
        '.companies-search-modal-income-range__checkbox:checked'
      ].join(',');
      const hasChecked = modal.querySelector(checkboxSelectors) !== null;
      button.classList.toggle('is-active', hasChecked);
    });
  }

  clearAll() {
    const checkboxes = this.element.querySelectorAll('.companies-search-modal-income-range__checkbox')
    checkboxes.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  toggleSection(event) {
    const toggleButton = event.currentTarget;
    const sectionBody = toggleButton.closest(".companies-search-modal__section")
                                    .querySelector(".companies-search-modal__section-body");

    toggleButton.classList.toggle("is-opened");
    if (sectionBody) {
      sectionBody.classList.toggle("is-opened");
    }
  }

  handleTouchStart(event) {
    if (window.innerWidth >= 992) return
    if (event.target.closest("button, a")) return

    this.startY = event.touches[0].clientY
    this.isDragging = true
    this.modalTarget.style.transition = "none"
    event.preventDefault()
  }

  handleTouchMove(event) {
    if (window.innerWidth >= 992 || !this.isDragging) return
    
    this.currentY = event.touches[0].clientY
    const deltaY = this.currentY - this.startY
    
    if (deltaY > 0) {
      event.preventDefault()
      this.modalTarget.style.transform = `translateY(${deltaY}px)`
    }
  }

  handleTouchEnd() {
    if (window.innerWidth >= 992 || !this.isDragging) return
    
    const deltaY = this.currentY - this.startY
    this.modalTarget.style.transition = "ease-in-out 0.4s"
    
    if (deltaY > this.threshold) {
      this.closeModal()
    } else {
      this.modalTarget.style.transform = ""
    }
    
    this.isDragging = false
  }
}